module.exports = __webpack_public_path__ + "media/images/reviews-b8864b591a734f6f26160db1e46decf6.png";